import { render, staticRenderFns } from "./chemDanger.vue?vue&type=template&id=d7f23b7a"
import script from "./chemDanger.vue?vue&type=script&lang=js"
export * from "./chemDanger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7f23b7a')) {
      api.createRecord('d7f23b7a', component.options)
    } else {
      api.reload('d7f23b7a', component.options)
    }
    module.hot.accept("./chemDanger.vue?vue&type=template&id=d7f23b7a", function () {
      api.rerender('d7f23b7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/chemDanger.vue"
export default component.exports